'use client';
import { useEffect } from 'react';

const useFocusEffect = (callback: () => void | (() => void)) => {
  useEffect(() => {
    const handleFocus = () => {
      callback();
    };

    // window.addEventListener('focus', handleFocus);
    handleFocus();

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [callback]);
};

export { useFocusEffect };
